import SecondFactorStep from 'components/pages/SecondFactor/SecondFactorStep';
import { buildPage, buildStaticProps } from 'utils/pageHelper';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { sessionId, username } = context.query;

  return await buildStaticProps('registration-login', {
    sessionId: sessionId || null,
    username: username || null,
  })(context);
};

export default buildPage(SecondFactorStep, {
  skipSSR: true,
  metaData: {
    title: 'Check your messages',
    description: "We've sent a message to you. Open it to confirm your account",
  },
  loggedInRedirect: '/dashboard',
});
